
import { defineComponent, onBeforeMount, ref } from 'vue';

export default defineComponent({
  name: 'UnderMaintenanceV2',
  props: {
    errorMessage: {
      type: String,
      default: '',
    },
  },
  setup(props) {
    const errorMsg = ref('');
    const helpmateLink = ref(localStorage.getItem('helpmateLink'));
    onBeforeMount(async () => {
      errorMsg.value = props.errorMessage;
    });
    return { errorMsg, helpmateLink };
  },
});
